module.exports = __webpack_public_path__ + "static/media/clipboard-list-solid.2e3e1d66.svg";